import queryString from 'query-string'
import api from '@utils/api'
import { http, $http } from '@utils'

export default {
    namespaced: true,
    actions:{
        async getCMSConfig({ commit }) {
            const res = await http.get(`${api.cmsHost}/publish/976/comment.json`)
            return res
        },
        async getMenus ({ commit }) {
            const url = `${api.mapi}/admin-b/workbench-menus`
            const json = await $http.get(url)
            return json
        },
        async submitCommit ({ commit }, param) {
            const url = `${api.bcomment}/api/v1/caller/btalk/comment/submit`
            const res = await $http.post(url, queryString.stringify({ ...param }), {
                headers: {
                    'content-Type': 'application/x-www-form-urlencoded'
                }
            })
            return res
        },
        async queryCommentList({ commit }, param) {
            const url = `${api.bcomment}/api/v1/caller/btalk/comment/auth/has_count/list?${queryString.stringify(param)}`
            const res = await $http.get(url)
            return res
        }
    }
}
